import { dataArrowDownLeft } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowDownLeft = /*#__PURE__*/createIcon(dataArrowDownLeft)
export default IconArrowDownLeft
